import {
    UPDATE_BUSINESS_DETAILS,
    UPDATE_CONTACT_DETAILS,
    UPDATE_BILLING_ADDRESS,
    UPDATE_TAX_DETAILS,
    UPDATE_MISC_DATA,
    UPDATE_ERROR_FIELDS,
    TOGGLE_REMOVE_MODAL,
    TOGGLE_LOADING
} from '../actions/types';
import { getBusinessDetailsObj, getContactPersonObj, getBillingAddressObj, getTaxObj, getMiscObj } from '../pages/add-edit-product/selectSupplier/utills';
const initialState = {
    businessDetails: getBusinessDetailsObj(),
    contactDetails: [getContactPersonObj()],
    billingAddress: [getBillingAddressObj()],
    taxDetails: getTaxObj(),
    removeModal: null,
    miscData: getMiscObj(),
    loading: false,
    errors: {}
};

export default (state = initialState, action) => {
	const payload = action.payload;
	switch (action.type) {
        case UPDATE_BUSINESS_DETAILS: 
            var prevDetails = state.businessDetails;
            var newDetails = {
                businessDetails: {
                    ...prevDetails,
                    ...payload
                }
            };
            return {
                ...state,
                ...newDetails
            };
        case UPDATE_CONTACT_DETAILS: 
            return {
                ...state,
                contactDetails: payload
            }; 
        case UPDATE_BILLING_ADDRESS: 
            return {
                ...state,
                billingAddress: payload
            };
        case UPDATE_TAX_DETAILS: 
            return {
                ...state,
                taxDetails: payload
            };  
        case UPDATE_MISC_DATA: 
            return {
                ...state,
                miscData: payload
            };    
        case TOGGLE_REMOVE_MODAL: 
            return {
                ...state,
                removeModal: payload
            };
        case TOGGLE_LOADING: 
            return {
                ...state,
                loading: payload
            };
        case UPDATE_ERROR_FIELDS: 
            return {
                ...state,
                errors: payload
            };
        default:
            return state;
    }
}